// extracted by mini-css-extract-plugin
export default {"mainContainer":"StatsDisplay_mainContainer__tJyxQ"};